import React, { useState } from "react";
import { View, TextInput, Image, TouchableOpacity, Text } from "react-native";
import { AppColors } from "../../../../../../utility/AppColors";
import { AppImages } from "../../../../../../utility/AppImages";
import StreamActionIcon from "../../../../../../Components/StreamActionIcons";

interface ChatInputProps {
  onSendMessage: (text: string) => void;
  onLike: () => void;
  onShare: () => void;
  onGift?: () => void; // Only present on mobile
  isMobile: boolean;
  canSend: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({
  onSendMessage,
  onLike,
  onShare,
  onGift,
  isMobile,
  canSend,
}) => {
  const [message, setMessage] = useState("");

  const handleSend = () => {
    if (message.trim().length === 0) return;
    onSendMessage(message);
    setMessage("");
  };

  return (
    <>
      {!isMobile && (
        <View
          style={{
            height: 1,
            backgroundColor: AppColors.gray_A3A3A3,
            marginVertical: 5,
          }}
        />
      )}
      <View
        style={{
          flexDirection: "row",
          gap: 8,
          alignItems: "center",
          marginVertical: 5,
        }}
      >
        {/* Text Input with Send Button Inside */}
        <View
          style={{
            flex: 1,
            height: 40,
            position: "relative",
          }}
        >
          <TextInput
            style={{
              flex: 1,
              height: 40,
              paddingVertical: 0,
              paddingHorizontal: 16,
              borderRadius: 8,
              paddingRight: 50,
              backgroundColor: "#1F2937",
              color: "#FFFFFF",
              fontSize: 14,
              borderWidth: 0.8,
              borderColor: "#374151",
            }}
            multiline={false}
            placeholderTextColor="#999999"
            placeholder="Write Here"
            value={message}
            onChangeText={setMessage}
            editable={canSend}
            onKeyPress={({ nativeEvent }) => {
              // Removed Enter check to avoid double send with onSubmitEditing
              if (nativeEvent.key === "Enter") {
                // handleSend(); // Causing double send
              }
            }}
            onSubmitEditing={handleSend} // Handle Enter on mobile
            returnKeyType="send"
          />

          {/* Send Button - Only show when typing */}
          {message.trim().length > 0 && (
            <View
              style={{
                position: "absolute",
                right: 0,
                top: 0,
                bottom: 0,
                justifyContent: "center",
              }}
            >
              <StreamActionIcon type="send" onPress={handleSend} />
            </View>
          )}
        </View>

        {/* Gift Button - Only for Mobile */}
        {isMobile && onGift && (
          <StreamActionIcon type="gift" onPress={onGift} />
        )}

        {/* Like Button */}
        <StreamActionIcon type="like" onPress={onLike} />

        {/* Share Button */}
        <StreamActionIcon type="share" onPress={onShare} />
      </View>
    </>
  );
};

export default ChatInput;
